// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__8u0ty","title":"AfterBackImages_title__2emTb","images":"AfterBackImages_images__3Efw9"};